import { useToast } from './useToast';

export const ToastExample = () => {
  const { addNotification } = useToast();

  const showSuccess = () => {
    addNotification({
      type: 'success',
      title: 'Success!',
      message: 'Operation completed successfully.',
      duration: 3000,
    });
  };

  const showError = () => {
    addNotification({
      type: 'error',
      title: 'Error!',
      message: 'Something went wrong. Please try again.',
      duration: 5000,
    });
  };

  const showWarning = () => {
    addNotification({
      type: 'warning',
      title: 'Warning',
      message: 'Please review your input before proceeding.',
      duration: 4000,
    });
  };

  const showInfo = () => {
    addNotification({
      type: 'info',
      title: 'Information',
      message: 'This is an informational message.',
      duration: 3000,
    });
  };

  const showSticky = () => {
    addNotification({
      type: 'success',
      title: 'Sticky Notification',
      message: 'This will stay until you close it!',
      duration: 0, // 0 means no auto-dismiss
    });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-white mb-4">Toast System Examples</h3>
      <p className="text-gray-400 mb-6">
        Click the buttons below to see different toast notifications in action. The toast uses React
        Context for state management.
      </p>

      <div className="flex flex-wrap gap-3">
        <button
          onClick={showSuccess}
          className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700 transition-colors"
        >
          Success Toast
        </button>
        <button
          onClick={showError}
          className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700 transition-colors"
        >
          Error Toast
        </button>
        <button
          onClick={showWarning}
          className="px-4 py-2 text-white bg-yellow-600 rounded hover:bg-yellow-700 transition-colors"
        >
          Warning Toast
        </button>
        <button
          onClick={showInfo}
          className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors"
        >
          Info Toast
        </button>
        <button
          onClick={showSticky}
          className="px-4 py-2 text-white bg-purple-600 rounded hover:bg-purple-700 transition-colors"
        >
          Sticky Toast
        </button>
      </div>
    </div>
  );
};
